import "../../styles/relatorio-institucional.css";

/**
 * Mensagem amigável quando o Relatório Preliminar ainda NÃO está disponível para
 * a unidade (avaliação não validada pela AUDIN). Explica, em linguagem simples,
 * o porquê e quando ele aparecerá — sem jargão de estados internos.
 */
export function RelatorioIndisponivel({ contexto }: { contexto?: "unidade" | "interno" }) {
  const interno = contexto === "interno";
  return (
    <div className="ri-indisponivel">
      <div className="ri-indisponivel-icone" aria-hidden="true">
        ⏳
      </div>
      <h3>Relatório ainda indisponível</h3>
      <p>
        O <strong>Relatório Preliminar de Maturidade</strong> é emitido apenas{" "}
        <strong>após a validação da CAINT (AUDIN)</strong> — a etapa em que a auditoria interna confere os
        resultados do 1º ciclo de avaliação.
      </p>
      <p>
        {interno
          ? "Assim que esta avaliação for concluída e validada pela AUDIN, o relatório poderá ser emitido aqui em PDF."
          : "Assim que a avaliação da sua unidade for concluída e validada, o relatório ficará disponível aqui para você emitir em PDF. Enquanto isso, você pode continuar preenchendo o Plano de Ação."}
      </p>
      <p className="ri-indisponivel-passos">
        Avaliação em campo → Diagnóstico dos avaliadores → <strong>Validação AUDIN</strong> → Relatório
        disponível
      </p>
    </div>
  );
}
